var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMsgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10087_97318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8809 0.746374C15.8372 0.702895 15.7823 0.672399 15.7222 0.658275C15.6622 0.644152 15.5994 0.646955 15.5409 0.666374L0.207578 6.99971C0.142319 7.02629 0.087164 7.07287 0.0500327 7.13276C0.0129014 7.19265 -0.00429551 7.26277 0.000911578 7.33304C0.00265014 7.3994 0.0237775 7.4638 0.0616872 7.5183C0.0995969 7.57279 0.15263 7.615 0.214245 7.63971L4.43425 9.27304C4.48539 9.29263 4.54045 9.29982 4.59492 9.29403C4.64938 9.28824 4.7017 9.26962 4.74758 9.23971L10.3476 5.23971C10.4157 5.18313 10.5034 5.15591 10.5916 5.16403C10.6797 5.17216 10.761 5.21497 10.8176 5.28304C10.8742 5.35111 10.9014 5.43887 10.8933 5.52702C10.8851 5.61516 10.8423 5.69646 10.7742 5.75304L6.10758 10.253C6.04377 10.3166 6.0078 10.403 6.00758 10.493V14.9997C6.00684 15.073 6.03077 15.1444 6.07551 15.2024C6.12024 15.2605 6.1832 15.3018 6.25425 15.3197C6.32466 15.3397 6.39973 15.3354 6.46742 15.3076C6.53512 15.2798 6.59152 15.2301 6.62758 15.1664L8.74091 11.553C8.76201 11.5158 8.79662 11.4881 8.83758 11.4757C8.87854 11.4633 8.92269 11.4671 8.96091 11.4864L12.8476 13.6264C12.893 13.6514 12.9436 13.6656 12.9954 13.6677C13.0472 13.6697 13.0988 13.6597 13.146 13.6383C13.1933 13.617 13.2349 13.5849 13.2676 13.5446C13.3003 13.5043 13.3231 13.457 13.3342 13.4064L16.0009 1.07304C16.0129 1.01282 16.0081 0.950447 15.9869 0.892804C15.9658 0.83516 15.9291 0.784486 15.8809 0.746374Z",
    fill: "url(#paint0_linear_10087_97318)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10087_97318",
    x1: 8.00368,
    y1: 0.649414,
    x2: 8.00368,
    y2: 15.3321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59FEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9872FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10087_97318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMsgGradient);
export default __webpack_public_path__ + "static/media/send_msg_gradient.6b4bdbd0.svg";
export { ForwardRef as ReactComponent };